<template>
  <img :src="resultPath" v-bind="$attrs" />
</template>

<script setup>
import { computed } from 'vue'
import { BASE_URL } from 'src/common/config'

const props = defineProps({
  src: {
    type: String,
    required: true,
    validator(value) {
      if (!value?.startsWith('/')) {
        throw new Error(`Invalid image path: "${value}". Path must start with '/'`)
      }
      return true
    },
  },
})

const resultPath = computed(() => BASE_URL + props.src)
</script>
